import type { ReactNode } from "react";

type Props = { children: ReactNode };

/**
 * Mobile-first shell. On phones it's full-bleed; on desktop we center a
 * phone-sized column with a soft background so the layout still feels intentional.
 */
export default function MoverShell({ children }: Props) {
  return (
    <div className="min-h-screen w-full bg-cream-100 md:bg-gradient-to-br md:from-cream-100 md:via-cream-50 md:to-cream-200">
      <div className="mx-auto w-full md:max-w-md md:my-6 md:rounded-3xl md:overflow-hidden md:border md:border-ink-200 bg-cream-50 min-h-screen md:min-h-[860px] md:shadow-[0_30px_80px_-30px_rgba(15,23,42,0.25)] flex flex-col relative">
        {children}
      </div>
    </div>
  );
}